import React, { useEffect} from "react";
import { Table } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import { getFinalPayList, doFinalPayDelete } from "../../../../redux/finalpay/finalPayState";
import { handleTableChange } from "../../../../utils/index";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import { useCRUDAccess } from "utils/useCRUDAccess";
import TableAddButton from "components/button/tableaddbutton";
import { MODULE_FINAL_PAYS } from "variables/constants";

const FinalPayTable = ({ recordList, pagination, doSearch, filters, doDelete, ...props }) => { 	
  	const checkCRUDAccess = useCRUDAccess();
	const accessRights = checkCRUDAccess(MODULE_FINAL_PAYS, ['view', 'edit', 'delete'], true);
	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
		{
	        title: `Employee ID`,
	        dataIndex: 'emp_code',
	        key: 'emp_code',
	        width: '12%',
	        render:(emp_code) => <span>{emp_code}</span> 
	    },
		{
	        title: `Employee`,
	        dataIndex: 'fpa_employee_name',
	        key: 'fpa_employee_name',
	        width: '20%',
	        sorter: true,
	        ...getColumnSearchProps('fpa_employee_name'),
	        render:(fpa_employee_name) => <span>{fpa_employee_name}</span>
	    },
	    {
	        title: `Hire Date `,
	        dataIndex: 'emp_hire_date',
	        key: 'emp_hire_date',
	        width: '14%',
	        render:(emp_hire_date) => <span>{emp_hire_date}</span>  
	    },
		{
	        title: `Separation Date `,
	        dataIndex: 'emp_separation_date',
	        key: 'emp_separation_date',
	        width: '14%',
	        render:(emp_separation_date) => <span>{emp_separation_date}</span>  
	    },
	    {
	        title: `Status`,
	        dataIndex: 'fpa_status_name',
	        key: 'fpa_status_name',
	        width: '15%',
	    },
	    {
	        title: `Released By`,
	        dataIndex: 'fpa_released_by_name',
	        key: 'fpa_released_by_name',
	        width: '15%',
	    },
	    {
	        title: <TableAddButton route={`/console/final-pays/add`} moduleId={MODULE_FINAL_PAYS}/>,
	        dataIndex: 'fpa_id',
	        key: 'fpa_id',
	        width: '10%',
	        render:(fpa_id) => <CrudOption 
				baseRoute="/console/final-pays" 
				recordId={fpa_id} 
				deleteHandler={doDelete}
				allowView={accessRights.view}
				allowEdit={accessRights.edit}
				allowDelete={accessRights.delete}
			/>
	    },
    ];
    
    useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"} {...props}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		
	      		<SearchFilter searchHandler={doSearch} filters={filters} pagination={pagination}/>
	      		
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.fpa_id}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.finalPay.finalPayList?.items,
	pagination: state.finalPay.finalPayList?.pagination,
	filters: state.finalPay.finalPayList?.filters,
  	requesting: state.finalPay.finalPayList?.requesting,
  	error: state.finalPay.finalPayList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getFinalPayList(filters)),
  	doDelete: (id) => dispatch(doFinalPayDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalPayTable);